import { each } from 'lodash';

import { deactivate } from '../utils/states';
import { getCookie, setCookie } from '../utils/cookies';


export default class Newsletter {
    constructor() {

        this.newsletter = {
            container: document.getElementById('active-newsletter'),
            closer: document.querySelector('#active-newsletter button[data-close]'),
        }

        this.form = document.querySelector("newsletter-form")


        if (getCookie('newsletter-banner') || getCookie('subscription')) {
            this.delete()
        }
        else {
            this.toggler()
            this.validation()
        }


        //this.createCarousel(this.carousel.element) // Init Carousel
    }

    toggler = () => {
        this.newsletter.closer.addEventListener('click', (event) => {
            deactivate(this.newsletter.container)
            setCookie('newsletter-banner', 'true', 1)
        })
    }

    delete = () => {
        if (this.newsletter.container) {
            this.newsletter.container.remove()
        }
        // if (document.getElementById('newsletter-modal')) {
        //     document.getElementById('newsletter-modal').remove()
        // }
    }


    validation = () => {
        if (this.form) {
            this.form.addEventListener('wpcf7mailsent', (event) => {
                setCookie('subscription', 'true', 10000)
            }, false);
        }
    }
    // createCarousel(target) {
    //     let carousel = new Swiper(target, {
    //         slidesPerView: 1,
    //         spaceBetween: 0,
    //         autoplay: {
    //             delay: 5000,
    //         },
    //         loop: false,
    //         rewind: true,
    //         navigation: {
    //             nextEl: ".swiper-button-next",
    //         },
    //         pagination: {
    //             el: this.carousel.dots,
    //             clickable: false,
    //         },
    //     })
    // }
}